import { DropdownMenuToggle } from "./dropdown-menu-toggle";
import { MobileMenu, MobileSubmenu } from "./mobile-menu";
import { ScrollToTopButton } from "./scroll-to-top-button";
import { SkipToMainContent } from "./skip-to-main-content";

(function initialize() {
  fixiOSClickEvents();
  initializeDropdownMenuToggles();
  initializeSkipToMainContent();
  initializeMobileMenu();
  initializeScrollToTopButton();
  initializeScrollToPage();
})();

// iOS does not delegate click events properly, so we must set a click handler
// on the children of the body.
// https://github.com/twbs/bootstrap/blob/main/js/src/dropdown.js#L141-L149
// https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
function fixiOSClickEvents() {
  const pageWrapper = document.getElementById("page-wrapper");
  pageWrapper?.addEventListener("click", () => void 0)
}

function initializeDropdownMenuToggles() {
  const dropdownMenuToggles = document.querySelectorAll(
    '[data-component="dropdown-toggle"]'
  );

  for (const toggleElement of dropdownMenuToggles) {
    const toggle = new DropdownMenuToggle(toggleElement as HTMLButtonElement);
    toggle.addEventListeners();
  }
}

function initializeMobileMenu() {
  const mobileSubmenuToggles = document.querySelectorAll(
    '[data-component="submenu-toggle"]'
  );

  const mobileSubmenus: MobileSubmenu[] = [];
  for (const toggleElement of mobileSubmenuToggles) {
    const expandedClass = toggleElement.getAttribute("data-submenu-expanded-class");
    const targetId = toggleElement.getAttribute("data-submenu-target") || "";
    const target = document.getElementById(targetId);
    const submenu = new MobileSubmenu({
      expandedClass: expandedClass as string,
      target: target as HTMLElement,
      toggleElement: toggleElement as HTMLButtonElement,

    });

    submenu.addEventListeners();
    mobileSubmenus.push(submenu);
  }

  const siteHeader = document.getElementById("site-header");
  const mobileMenuToggleElement = document.getElementById("mobile-menu-toggle");
  const expandedClass = mobileMenuToggleElement?.getAttribute("data-mobile-menu-expanded-class");
  const mobileMenuElement = document.getElementById("mobile-menu");
  const openLabel = mobileMenuToggleElement?.getAttribute("data-open-label");
  const closeLabel = mobileMenuToggleElement?.getAttribute("data-close-label");

  const mobileMenu = new MobileMenu({
    expandedClass: expandedClass as string,
    headerElement: siteHeader as HTMLElement,
    menuElement: mobileMenuElement as HTMLElement,
    submenus: mobileSubmenus,
    toggleElement: mobileMenuToggleElement as HTMLButtonElement,
    toggleCloseMenuLabel: closeLabel as string,
    toggleOpenMenuLabel: openLabel as string,
  });

  mobileMenu.addEventListeners();
}

function initializeSkipToMainContent() {
  let skipToMainContentLink: HTMLLinkElement | null;
  skipToMainContentLink = document.querySelector("#skip-to-main-content");

  if (skipToMainContentLink === null) return;

  const hideSkipToMainContentLink = () => {
    if (skipToMainContentLink === null) return; // Make TypeScript happy.
    skipToMainContentLink.style.display = "none";
  };

  const href = skipToMainContentLink.href;
  if (!href) {
    hideSkipToMainContentLink();
    return;
  }

  if (!href.toString().match(/#.+/)) {
    hideSkipToMainContentLink();
    return;
  }

  if (!document.querySelector(new URL(href).hash)) {
    hideSkipToMainContentLink();
    return;
  }

  const skipToMainContent = new SkipToMainContent(skipToMainContentLink);
  skipToMainContent.addEventListeners();
}

function initializeScrollToTopButton() {
  const scrollToTopButton = new ScrollToTopButton({
    footerElement: document.getElementById("site-footer"),
  });

  scrollToTopButton.activate();
}

function initializeScrollToPage() {
  const scrollButtons = document.querySelectorAll('[data-scroll-target]');

  for(const scrollButton of scrollButtons) {
    scrollButton.addEventListener("click", function scrollToId() {
      console.log("you clicked me")
      const targetElementId = this.getAttribute("data-scroll-target");
      const targetElement = document.getElementById(targetElementId);

      if (!targetElement) return;

      targetElement.scrollIntoView();
    })
  }
}
